<template>
  <v-dialog width="400px" :value="value" @input="toggleModal" scrollable >
    <v-card class="error pb-2" style="border-radius: 10px">
      <v-card-text>
        <v-row>
          <v-col class="text-center py-4" cols="12" >
            <v-icon color="white" size="50">warning</v-icon>
          </v-col>
          <v-col cols="12" class="white--text text-center">
            <h4>
              Este agente esta desconectado ¿Estas seguro?
            </h4>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="white" outlined @click="toggleModal(false)">{{ $t('general.cancel') }}</v-btn>
        <v-btn color="white" class="error--text" @click="submit" :loading="deletingUser">Transferir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      socket: state => state.conversations.socket,
      selectedRoom: state => state.conversations.selectedRoom
    })
  },
  data () {
    return {
      deletingUser: false
    }
  },
  methods: {
    async submit () {
      try {
        this.deletingUser = true

        const data = {
          action: 'transfer',
          advisorId: this.adviser.userId,
          roomId: this.selectedRoom
        }

        await this.socket.emit('roomAction', data, err => {
          if (err) return notifications.error(err)
          this.loading = false

          this.socket.emit('leaveRoom', { roomId: this.selectedRoom })
          this.$store.commit('SET_MESSAGES', [])
          this.$store.commit('SET_SELECTED_ROOM', '')
          this.$store.commit('SET_ROOM_INFO', '')
        })
        this.toggleModal(false)
      } catch (e) {
        console.log(e)
      }
    },
    toggleModal (value) {
      this.deletingUser = false
      this.$emit('clearSelectedUser')
      this.$emit('input', value)
    }
  },
  props: ['adviser', 'value']
}
</script>
